'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var spaces = require('../../../constants/spaces.js');
var Space = require('../../Space/src/Space.js');
var Menu_module = require('../styles/Menu.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Menu Item Group component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.ItemGroup title="hint">
 *   <Menu.Item>1 год</Menu.Item>
 * </Menu.Item>
 * ```
 */
const MenuItemGroup = React__namespace.forwardRef((props, ref) => {
    const { label, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Menu_module.default);
    const classNames = cx(className, 'item-group');
    return (React__namespace.createElement(Space.Space, { ref: ref, direction: "vertical", className: classNames, ...restProps },
        React__namespace.createElement(Space.Space, { align: "center", size: spaces.SPACE_SIZES.S4, className: cx('item-base', 'label') }, label),
        children));
});
MenuItemGroup.defaultProps = {};
MenuItemGroup.displayName = 'MenuItemGroup';

exports.MenuItemGroup = MenuItemGroup;
//# sourceMappingURL=MenuItemGroup.js.map
